import React from "react";
import SntIcon, { SntIconProps } from "./SntIcon";

const SntInOrientationIcon: React.FC<SntIconProps> = (props) => {
  return (
    <SntIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.828408 14.9706L4.11714 8.86292C3.79207 7.54746 4.14355 6.09909 5.17157 5.07107C6.22144 4.0212 7.70972 3.67694 9.0471 4.03828L15.0078 0.865698L11.8215 6.71514C12.2454 8.08702 11.9144 9.64199 10.8284 10.7279C9.75053 11.8058 8.2105 12.1399 6.84611 11.7303L0.828408 14.9706ZM6.58579 9.24264C7.36684 10.0237 8.63317 10.0237 9.41421 9.24264C10.1953 8.46159 10.1953 7.19526 9.41421 6.41421C8.63317 5.63316 7.36684 5.63316 6.58579 6.41421C5.80474 7.19526 5.80474 8.46159 6.58579 9.24264Z"
      ></path>
    </SntIcon>
  );
};

export default SntInOrientationIcon;
